<template>
    <div>
      <div class="wp-relative">
        <div class="dt-contact-grid">
        <IcoListModel :title="''" :ListInfo="contactList"/>
        
        <IcoListModel :title="'长按添加微信'" :QRCode="QRCode"/>
        </div>
      </div>

      <div class="wp-relative">
        <h4 style="text-align: center; margin-top: 40px; margin-bottom: 40px;">
            加入Telegram群可优先获取每日战报，独家图片视频
            及最新资讯，扫码或打开链接即可免费加入&nbsp;
             
            <em><a class=""  :href="TelegramUrl" target="_blank" rel="noopener noreferrer">{{ TelegramUrl }}</a></em>
        </h4> 
        <IcoListModel :title="' '" :QRCode="TelegramQRCode"/>
      </div>
       
      <div class="wp-relative"> 
        
        <TitleModel
            :title="'应聘及商务合作请联系：'"
            :content="''"
            />  
        <IcoListModel :title="''" :ListInfo="contactList2"/>
      </div>
      
      <div class="wp-relative">
        <p class="real-time">本店MM为预约制，每天即时更新网站，您在本页浏览到的皆为在线可约，点击封面照片查看全部靓照及资料。为避免错过心仪的她，强烈建议您订阅或收藏本站https://www.seattletaotao.com</p>
      </div>

      <div class="wp-relative"> 
        <IcoListModel :title="'桃桃家，西雅图No.1伴君品牌，6年口碑值得信赖，万千狼友的最佳选择。做服务，我们是认真的！'" />
      </div> 
    </div>
</template>

<script>
import IcoListModel from '@/components/IcoListModel.vue';
import TitleModel from '@/components/TitleModel.vue';
export default{ 
    components: {
      IcoListModel,
      TitleModel
    },
    data() {
      return {
        contactList: [
        {
          ico: 'icon-phone_c',//'fa fa-phone-square',
          label: '电话/短信',
          value: '425-999-6494'
        },
        {
          ico:'icon-line_c',
          label: 'Line搜索id',
          value:    'N/A'
        },
        {
          ico:'icon-line_c',
          label: 'Line搜索电话',
          value:  'N/A'
        },
        {
          ico:'icon-whatsapp_c',//'fa fa-qq',
          label: 'WhatsApp',
          value: '*********'
        },
        {
          ico:'icon-telegram_c',//'fa fa-telegram',
          label: 'Telegram',
          value: 'seattletaotao'
        },
        {
          ico:'icon-wechat_c',//'fa fa-weixin',
          label: 'WeChat',
          value: 'Aaron-518618'
        }
       ], 
       QRCode: '',//'./asset/img/CR_WeChat.png'
       TelegramQRCode:'', 
       TelegramUrl:'https://t.me/taotaosea',
       contactList2: [
        {
          ico:'icon-wechat_c',
          label: 'WeChat',
          value: 'taotao6688'
        },
        {
          ico:'icon-phone_c',//'fa fa-phone-square',
          label: '电话/短信',
          value: '425-999-6494'
        },
        {
          ico:'icon-Email_c',//'fa fa-envelope',
          label: 'Email',
          value: '******@qq.com'
        }]
        ,
        configs:{}
      }
    },
    mounted() {
      try {
        let _baseInfo = JSON.parse(this.$local.getItem('baseInfoJson'));  
        let _confs = _baseInfo.config[0]; 
        this.updateContactValue('电话/短信', _confs.phone);
        this.updateContactValue('Line搜索id', _confs.line_id);
        this.updateContactValue('Line搜索电话', _confs.line_phone); 
        this.updateContactValue('WhatsApp', _confs.whatsapp);
        this.updateContactValue('Telegram', _confs.telegram);
        this.updateContactValue('WeChat', _confs.wechat);

        this.updateContactValue2('WeChat', _confs.recruitment_wechat);
        this.updateContactValue2('电话/短信', _confs.recruitment_phone);
        this.updateContactValue2('Email', _confs.email);

        this.QRCode =this.$store.state.apiImgUrl+ _confs.line_qrimage;
        this.TelegramQRCode =this.$store.state.apiImgUrl+ _confs.telegram_qrimage;
        // this.TelegramUrl = 'https://t.me/' + _confs.telegram; 

      } catch (error) {
        console.log('---error ',error)
      }
    },
    methods:{
      updateContactValue(label, newValue) {
        // 查找对应的item并更新其value
        const item = this.contactList.find(item => item.label === label);
        if (item) {
          item.value = newValue;
        }
      },
        // 也可以添加一个方法来动态更新contactList2
      updateContactValue2(label, newValue) {
        const item = this.contactList2.find(item => item.label === label);
        if (item) {
          item.value = newValue;
        }
      }
    }
}
</script>

<style lang="scss" scoped>
@import url(@/assets/css/commPage.scss);
h4{
    font-weight: bold !important;
    background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent;
    color: #fbedcd;
    font: normal 25px / 30px "Roboto", Helvetica, Arial, Verdana, sans-serif;
    text-transform: none;
}
</style>